var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 15.3231C16.632 15.3231 15.4264 15.996 14.6692 17.0195L8.12262 13.6673C8.23131 13.2968 8.30769 12.9128 8.30769 12.5077C8.30769 11.9582 8.19503 11.4358 8.0004 10.9553L14.8517 6.83243C15.6142 7.72726 16.7349 8.30769 18 8.30769C20.2906 8.30769 22.1538 6.44442 22.1538 4.15385C22.1538 1.86328 20.2906 0 18 0C15.7094 0 13.8462 1.86328 13.8462 4.15385C13.8462 4.68171 13.9548 5.18243 14.1352 5.64729L7.26346 9.78222C6.50165 8.91397 5.39709 8.35385 4.15385 8.35385C1.86328 8.35385 0 10.2171 0 12.5077C0 14.7983 1.86328 16.6615 4.15385 16.6615C5.54446 16.6615 6.77035 15.9688 7.52469 14.9166L14.0497 18.258C13.9296 18.6459 13.8462 19.05 13.8462 19.4769C13.8462 21.7675 15.7094 23.6308 18 23.6308C20.2906 23.6308 22.1538 21.7675 22.1538 19.4769C22.1538 17.1864 20.2906 15.3231 18 15.3231Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.55ed32688da43e7c02ee8eb93bbb17d6.svg";
export { ForwardRef as ReactComponent };